// Editor de "Tipos de peça visíveis" de um Cliente, em estado local. Usado
// dentro do modal de Cliente (novo ou edição). `null` = sem restrição — o
// lançamento de OS deste hotel mostra todos os Tipos ativos, inclusive um
// criado depois; uma lista marca só esses, para sempre, até alguém mudar aqui.

import type { Snapshot } from "../../domain/snapshot.ts";
import { el } from "../ui.ts";
import { campo } from "./_cadastro.ts";
import { multiSelect } from "./_multi-select.ts";

export interface TiposVisiveisEditor {
  element: HTMLElement;
  valor(): string[] | null;
}

export function tiposVisiveisEditor(
  snap: Pick<Snapshot, "tiposPeca">,
  atual: readonly string[] | null,
): TiposVisiveisEditor {
  const tiposAtivos = [...snap.tiposPeca].filter((t) => t.ativo);
  // Um Tipo já marcado pode ter sido inativado depois — mantém ele na lista
  // (rotulado) para não sumir da seleção só por salvar o Cliente de novo:
  // sem isso, `ms.selecionados()` filtraria por `itens` e o dropava calado.
  const idsAtivos = new Set(tiposAtivos.map((t) => t.id));
  const inativosMarcados = snap.tiposPeca.filter(
    (t) => !t.ativo && (atual ?? []).includes(t.id),
  );
  const itens = [...tiposAtivos, ...inativosMarcados].sort((a, b) =>
    a.nome.localeCompare(b.nome, "pt-BR"),
  );

  const modo = el("select", {}) as HTMLSelectElement;
  for (const [v, rotulo] of [
    ["todos", "Todos os Tipos de Peça (padrão)"],
    ["somente", "Somente os Marcados Abaixo"],
  ] as const) {
    const o = el("option", { value: v }, rotulo) as HTMLOptionElement;
    if ((atual == null ? "todos" : "somente") === v) o.selected = true;
    modo.append(o);
  }

  const ms = multiSelect({
    rotulo: "Tipos de peça visíveis",
    itens: itens.map((t) => ({
      id: t.id,
      nome: idsAtivos.has(t.id) ? t.nome : `${t.nome} (inativo)`,
    })),
    marcadosPorPadrao: atual ?? tiposAtivos.map((t) => t.id),
  });
  const msWrap = el("div", { class: "campo" }, ms.element);
  msWrap.hidden = atual == null;
  modo.addEventListener("change", () => {
    msWrap.hidden = modo.value !== "somente";
  });

  return {
    element: el(
      "div",
      {},
      campo("Contagem Recebida no lançamento de OS", modo),
      el(
        "p",
        { class: "muted" },
        "Restringe quais tipos de peça aparecem na contagem recebida ao lançar " +
          "uma OS deste hotel. A importação de OS por .csv ignora esta lista.",
      ),
      msWrap,
    ),
    valor: () => (modo.value === "todos" ? null : ms.selecionados()),
  };
}
